class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.endDate = element.getAttribute('data-end-date');
    this.endTime = element.getAttribute('data-end-time');
    this.timezone = element.getAttribute('data-timezone') || 'UTC';
    
    // Get DOM elements
    this.daysElement = element.querySelector('.counter__days');
    this.hoursElement = element.querySelector('.counter__hours');
    this.minutesElement = element.querySelector('.counter__minutes');
    this.secondsElement = element.querySelector('.counter__seconds');
    
    // Set target date
    this.targetDate = new Date(`${this.endDate}T${this.endTime}:00`);
    
    // Start the countdown
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.targetDate.getTime() - now;

    if (distance < 0) {
      this.displayTime(0, 0, 0, 0);
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.displayTime(days, hours, minutes, seconds);
  }

  displayTime(days, hours, minutes, seconds) {
    if (this.daysElement) this.daysElement.textContent = this.padZero(days);
    if (this.hoursElement) this.hoursElement.textContent = this.padZero(hours);
    if (this.minutesElement) this.minutesElement.textContent = this.padZero(minutes);
    if (this.secondsElement) this.secondsElement.textContent = this.padZero(seconds);
  }

  padZero(num) {
    return num.toString().padStart(2, '0');
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Initialize all countdown timers on the page
document.addEventListener('DOMContentLoaded', function() {
  const timers = document.querySelectorAll('.image-with-text__counter');
  timers.forEach(timer => {
    new CountdownTimer(timer);
  });
});

// Re-initialize when sections are reloaded (Shopify theme editor)
document.addEventListener('shopify:section:load', function(event) {
  const timers = event.target.querySelectorAll('.image-with-text__counter');
  timers.forEach(timer => {
    new CountdownTimer(timer);
  });
});
